<div class="title">Profile Details</div>
<form [formRoot]="profileForm">
  <div class="input-container">
    <div>
      @if (profileForm.firstName().valid() || !profileForm.firstName().touched()) {
        <label for="firstName">First Name</label>
      } @else {
        <span class="red">
          {{ hasError(profileForm.firstName, 'required') ? 'Please enter your first name' : '' }}
          {{
            hasError(profileForm.firstName, 'nameIsEmail')
              ? 'This looks like an email address, please enter your name'
              : ''
          }}
        </span>
      }
    </div>
    <input
      id="firstName"
      [formField]="profileForm.firstName"
      [class.red]="profileForm.firstName().invalid() && profileForm.firstName().touched()"
    />
  </div>
  <div class="input-container">
    <div>
      @if (profileForm.lastName().valid() || !profileForm.lastName().touched()) {
        <label for="lastName">Last Name</label>
      } @else {
        <span class="red">
          {{ hasError(profileForm.lastName, 'required') ? 'Please enter your last name' : '' }}
          {{
            hasError(profileForm.lastName, 'nameIsEmail')
              ? 'This looks like an email address, please enter your name'
              : ''
          }}
        </span>
      }
    </div>
    <input
      id="lastName"
      [formField]="profileForm.lastName"
      [class.red]="profileForm.lastName().invalid() && profileForm.lastName().touched()"
    />
  </div>

  <div class="input-container">
    <div>
      <label for="email">Email Address</label>
    </div>
    <input type="email" id="email" placeholder="YourName@Company.com" [formField]="profileForm.email" />
  </div>
  <div class="input-container">
    <div>
      @if ((profileForm.country().valid() || !profileForm.country().touched()) && profileForm.countryOther().valid()) {
        <label for="country">Country</label>
      } @else {
        <span class="red">
          {{ hasError(profileForm.country, 'required') ? 'Please select your country' : '' }}
          {{ hasError(profileForm.countryOther, 'required') ? 'Please enter your country' : '' }}
        </span>
      }
    </div>
    <div
      class="input"
      [class.red]="
        (profileForm.country().invalid() && profileForm.country().touched()) || profileForm.countryOther().invalid()
      "
    >
      <mat-select
        id="country"
        [formField]="profileForm.country"
        panelClass="role-select-panel"
        placeholder="Please select your country"
        [class.red]="
          (profileForm.country().invalid() && profileForm.country().touched()) || profileForm.countryOther().invalid()
        "
      >
        @for (country of COUNTRIES; track country) {
          <mat-option [value]="country">{{ country }}</mat-option>
        }
      </mat-select>
      @if (isOtherCountry()) {
        <input
          animate.enter="gnx-grow-flex-in-500"
          animate.leave="gnx-grow-flex-out-500"
          placeholder="Please specify country"
          [formField]="profileForm.countryOther"
        />
      }
    </div>
  </div>
  <div class="input-container">
    <div>
      @if (profileForm.role().valid() || !profileForm.role().touched()) {
        <label for="role"> Professional Role </label>
      } @else {
        <span class="red">
          {{ hasError(profileForm.role, 'required') ? 'Please enter in your role' : '' }}
        </span>
      }
    </div>
    <div class="input" [class.red]="profileForm.role().invalid() && profileForm.role().touched()">
      <mat-select
        id="role"
        [formField]="profileForm.role"
        panelClass="role-select-panel"
        placeholder="Please select your role in the organization"
        [class.red]="profileForm.role().invalid() && profileForm.role().touched()"
      >
        @for (role of ROLES; track role) {
          <mat-option [value]="role">{{ role }}</mat-option>
        }
      </mat-select>
    </div>
  </div>
  <div class="input-container">
    <div>
      <label for="organizationalRole">Organizational Role</label>
    </div>
    <input id="organizationalRole" [formField]="profileForm.organizationalRole" />
  </div>
  @if (showUserRole()) {
    <div class="input-container">
      <div>
        <label for="userRole">User Role</label>
      </div>
      <input id="userRole" [formField]="profileForm.userRole" />
    </div>
  }
</form>
<hr />
<div class="change-password">
  <div class="subheader">Password</div>
  <div>
    <div class="password-hint">
      <a [routerLink]="['/reset']" [queryParams]="{ step: 2 }">Change Password</a>
    </div>
  </div>
</div>

<div class="right-column">
  <button class="cancel-btn" [disabled]="!profileForm().dirty()" (click)="onCancel()">Cancel</button>
  <button class="save-btn" [disabled]="!profileForm().dirty()" (click)="onSubmit()">
    @if (!auth0Store.updateUserInProgress()) {
      <span>Save</span>
    }
    @if (auth0Store.updateUserInProgress()) {
      <gnx-dots-loader />
    }
  </button>
</div>
